// src/components/ItemsAndInventory/Barcode.tsx
import React, { useEffect, useRef } from "react";
import JsBarcode from "jsbarcode";
import { ItemInfo } from "../../models/item";

declare global {
	interface Window {
		JsBarcode: any;
	}
}

interface BarcodeProps {
	itemInfo: ItemInfo;
	itemKey: string;
}

const Barcode: React.FC<BarcodeProps> = ({ itemKey, itemInfo }) => {
	const svgRef = useRef<SVGSVGElement | null>(null);

	// generate text value for barcode by removing last number from purchasePrice and sellPrice and concatenating with name and minProfitPercent
	const textValue =
		`${itemInfo.purchasePrice}_${itemInfo.name}_${itemInfo.sellPrice}_${itemInfo.minProfitPercent}`.split(
			"_"
		);
	const purchasePrice = textValue[0].slice(0, -1);
	const name = textValue[1].replaceAll(" ", "");
	const sellPrice = textValue[2].slice(0, -1);
	const minProfitPercent = textValue[3];
	const text = `(Item Code: ${purchasePrice}${name}${sellPrice}${minProfitPercent}) (Price:${textValue[2]})`;

	useEffect(() => {
		if (svgRef.current) {
			try {
				JsBarcode(svgRef.current, itemInfo.itemCode, {
					format: "CODE128",
					displayValue: true,
					text: text,
					fontSize: 18,
					textMargin: 0,
				} as JsBarcode.Options);
			} catch (e) {
				console.error("Barcode generation failed:", e);
			}
		}
	}, [itemInfo.itemCode, text]);

	return (
		<div style={{ width: "50mm", height: "30mm" }}>
			<svg ref={svgRef}></svg>
		</div>
	);
};

export default Barcode;
